export default __webpack_public_path__ + "static/media/nl-ilustracao-2.ddf6214e.webp";